import React from "react";
import Tabs from "components/tabs";
import { languages } from "utils/constants";
import RichText from "components/rich-text";

const Ingredients = ({ data, title, lang }) => {
	const filtered = data?.find((e) => e.title && e.title === lang);
	return (
		<>
			<h2 className="my-4 bg">{title}</h2>
			<RichText value={data && filtered?.content} />
		</>
	);
};

const IngredientsTab = ({ data }) => {
	const tabs = languages.map(lang => ({
		label: lang,
		content: data.product.details.products.map((p, i) =>
			<Ingredients key={i} data={p.inBundleDetails?.ingredients} title={p?.title} lang={lang} />)
	}));

	return <Tabs tabs={[...tabs]} />;
};

export default IngredientsTab;